import moment from 'moment'
import { TIME_FORMAT } from 'config/consts'

const timeFormatter = (time, format = TIME_FORMAT) => {
	const TIME = moment(time, 'hh:mm:ss A Z').utc()
	return TIME.isValid() ? TIME.format(format) : null
}

export default timeFormatter
